import { isMobile } from "react-device-detect";
import Popup from "../../other/Popup";
import { BotonsHaPagat } from "../FormResponses";
import { useEffect, useState } from "react";
import { fetchAPI } from "../../../utils/utils";

function isSvgUrl(url) {
    if (!url || typeof url !== 'string') return false;
    return url.toLowerCase().endsWith('.svg') || 
           url.startsWith('data:image/svg') ||
           url.includes('.svg?');
}

function PopupFormImage({
    modalIsClosed,
    setModalIsClosed,

    name,
    user,
    element,
    response,

    getOtherQuestionsArray,
    setFocusedResponseInfo,
    recognize,

    evId,
    form,
    statusPagaments,
    setStatusPagaments,
    socket,
}) {
    const [imgsURL, setImgsURL] = useState({})
    const [otherQuestionsArray, setOtherQuestionsArray] = useState(null)
    const [recognitionResults, setRecognitionResults] = useState({})

    const positionInArray = otherQuestionsArray
        ?.findIndex(x => String(x.user) === String(user))

    const next_response = () => {
        if (positionInArray < 0) {
            // setFocusedResponseInfo(otherQuestionsArray[0])
            return;
        }

        if (positionInArray >= otherQuestionsArray.length - 1) {
            // setFocusedResponseInfo(otherQuestionsArray[0])
            return;
        }

        setFocusedResponseInfo(otherQuestionsArray[positionInArray + 1])
    }

    const prev_response = () => {
        if (positionInArray <= 0) {
            // setFocusedResponseInfo(otherQuestionsArray[otherQuestionsArray.length - 1])
            return;
        }

        setFocusedResponseInfo(otherQuestionsArray[positionInArray - 1])
    }

    useEffect(() => {
        if (imgsURL[user] && element?.isComprovant && typeof recognize === 'function') {
            recognize(imgsURL[user])
                .then(data => setRecognitionResults(prev => ({ ...prev, [user]: data })))
                .catch(() => setRecognitionResults(prev => ({ ...prev, [user]: false })))
        } else if (imgsURL[user] && element?.isComprovant) {
            console.error('recognize is not a function:', typeof recognize, recognize);
            setRecognitionResults(prev => ({ ...prev, [user]: false }));
        }
    }, [
        imgsURL[user],
    ])

    useEffect(() => {
        if (!element) return;
        setOtherQuestionsArray(getOtherQuestionsArray(element))
    }, [
        element
    ])

    useEffect(() => {
        if (!otherQuestionsArray || !evId || !element?.id) return;

        otherQuestionsArray?.forEach(({ user: userId }) => {
            if (!imgsURL[userId]) {
                fetchAPI(`/form_image_url/${evId}/${element?.id}/${userId}`, (res) => {
                    fetch(res?.url)
                        .then(res => res.text())
                        .then(url => url.indexOf('Error') > 0 ? false : url)
                        .then(data => {
                            setImgsURL(prev => ({ ...prev, [userId]: data }));
                            if (data && typeof recognize === 'function') {
                                recognize(data)
                                    .then(recognitionData => setRecognitionResults(prev => ({ ...prev, [userId]: recognitionData })))
                                    .catch(() => setRecognitionResults(prev => ({ ...prev, [userId]: false })))
                            } else if (data) {
                                console.error('recognize is not a function:', typeof recognize, recognize);
                                setRecognitionResults(prev => ({ ...prev, [userId]: false }));
                            }
                        })
                }, false, false)
            }
        });
    }, [
        otherQuestionsArray,
        evId,
        element?.id,
    ])

    useEffect(() => {
        if (element?.id === undefined || evId === undefined || user === undefined) return;

        fetchAPI(`/form_image_url/${evId}/${element?.id}/${user}`, (res) => {
            fetch(res?.url)
                .then(res => res.text())
                .then(url => url.indexOf('Error') > 0 ? false : url)
                .then(data => setImgsURL(prev => ({ ...prev, [user]: data })))
        }, false, false)
    }, [element?.id, evId, user])

    useEffect(() => {
        const handleKeyPress = (e) => {
            if (e.key === 'Escape') {
                setModalIsClosed(true)
            } else if (e.key === 'ArrowLeft') {
                next_response() // Reverse
            } else if (e.key === 'ArrowRight') {
                prev_response() // Reverse
            }
        };

        window.addEventListener('keyup', handleKeyPress);

        return () => {
            window.removeEventListener('keyup', handleKeyPress);
        };
    }, [
        setModalIsClosed,
        prev_response,
        next_response,
    ]);

    return (
        <Popup
            className="popup-form-image"
            closed={modalIsClosed}
            setClosed={setModalIsClosed}
            width={isMobile ? '90%' : '70%'}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: isMobile ? 10 : 20,
                    width: '98%',
                }}
            >
            <div
                style={{
                    flex: isMobile ? 'auto' : 3,
                    width: '100%',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        gap: 10,
                        margin: isMobile ? '5px 0' : 10,
                    }}
                >
                    {
                        !element?.isComprovant || !imgsURL[user] ? null :
                        isSvgUrl(imgsURL[user]) ? (
                            <span style={{ fontSize: 24, color: '#68C285', width: '100%', textAlign: 'center' }}>✓ Rebut auto-generat</span>
                        ) :
                        recognitionResults[user] ? (
                            <>
                                <span>{recognitionResults[user].date || '??/??/????'}</span>
                                <span style={{ fontWeight: 'bold' }}>{recognitionResults[user].import || '?€'}</span>
                            </>
                        ) : recognitionResults[user] === undefined ? 'Llegint...'
                        : 'Error'
                    }
                </div>
                <img
                    src={
                        imgsURL[user] === undefined ? 'https://retchhh.files.wordpress.com/2015/03/loading1.gif' :
                        !imgsURL[user] ? "https://upload.wikimedia.org/wikipedia/commons/a/a3/Image-not-found.png" :
                        imgsURL[user]
                    }
                    alt="Sense imatge"
                    onClick={() => {
                        const image = new Image();
                        image.src = imgsURL[user]

                        const w = window.open('')
                        w.document.write(image.outerHTML)
                    }}
                    style={{
                        width: '100%',
                        height: isMobile ? '50vh' : 'auto',
                        objectFit: 'contain',
                        border: '1px solid #ccc',
                        borderRadius: 10,
                        cursor: 'zoom-in',
                    }}
                />
            </div>
            <div
                style={{
                    flex: isMobile ? 'auto' : 1,
                    flexDirection: 'column',
                    alignSelf: isMobile ? 'center' : 'flex-start',
                    marginTop: isMobile ? 10 : 50,
                    width: isMobile ? '100%' : 'auto',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        gap: 15,
                        margin: '15px 0',
                    }}
                >
                    <button
                        disabled={positionInArray >= otherQuestionsArray?.length - 1}
                        onClick={next_response}
                        style={{
                            padding: isMobile ? '12px 20px' : undefined,
                            fontSize: isMobile ? '16px' : undefined,
                            minWidth: '100px',
                        }}
                    >
                        Anterior
                    </button>
                    <button
                        className="primary"
                        disabled={positionInArray <= 0}
                        onClick={prev_response}
                        style={{
                            padding: isMobile ? '12px 20px' : undefined,
                            fontSize: isMobile ? '16px' : undefined,
                            minWidth: '100px',
                        }}
                    >
                        Següent
                    </button>
                </div>
                <div
                    style={{
                        margin: isMobile ? '15px 0' : 15,
                        fontSize: isMobile ? 18 : 20,
                        fontWeight: 'bold',
                        textAlign: 'center',
                        backgroundColor: '#f5f5f5',
                        borderRadius: 10,
                        padding: 15,
                        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                    }}
                >
                    {name}
                </div>
                {
                    element?.isComprovant === true && (
                        <div style={{ width: '100%' }}>
                            <BotonsHaPagat
                                response={response}
                                form={form}
                                element={element}
                                statusPagaments={statusPagaments}
                                setStatusPagaments={setStatusPagaments}
                                user={user}
                                socket={socket}
                            />
                        </div>
                    )
                }
            </div>
            </div>
        </Popup>
    )
}

export default PopupFormImage;